import { Navigate, Route, Routes } from 'react-router-dom'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import theme from './theme'
import HomePage from './pages/HomePage'
import Login from './pages/Login'
// import MerchantSignup from './pages/MerchantSignup'
import DashboardRouter from './pages/DashboardRouter'
import StorePage from './pages/StorePage'
import BookingPage from './pages/BookingPage'
import AppointmentDetailsPage from './pages/AppointmentDetailsPage'
import AgreementSignPage from './pages/AgreementSignPage'
import SquareOAuthCallback from './pages/SquareOAuthCallback'
import MerchantAppointmentsPage from './pages/MerchantAppointmentsPage'
import PrivacyPolicy from './pages/PrivacyPolicy'
import Terms from './pages/Terms'

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Routes>
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          {/* <Route path="/merchant-signup" element={<MerchantSignup />} /> */}
          <Route path="/dashboard" element={<DashboardRouter />} />
          <Route path="/appointments" element={<MerchantAppointmentsPage />} />
          <Route path="/store/:slug" element={<StorePage />} />
          <Route path="/store/:slug/book" element={<BookingPage />} />
          <Route path="/appointment/:appointmentId" element={<AppointmentDetailsPage />} />
          <Route path="/agreements/:signedAgreementId" element={<AgreementSignPage />} />
          <Route path="/oauth/square/callback" element={<SquareOAuthCallback />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </ThemeProvider>
    </LocalizationProvider>
  )
}

export default App